<div class="form-group">
  <label for="member">Member</label>

  <select class="custom-select"
          id="member" name="member"
          [(ngModel)]="member">
    <option *ngFor="let member of getActionableMembers()"
            [ngValue]="member">
      {{ member.first_name }} {{ member.last_name }}
    </option>
  </select>
</div>

<ng-container *ngIf="member">
  <p *ngIf="propExists(member.member_freeze_date)">
    Currently scheduled to be frozen on: <b>{{ dateStringFromISO8601(member.member_freeze_date) }}</b>
    <ng-container *ngIf="member.member_unfreeze_date">
      and unfrozen on: <b>{{ dateStringFromISO8601(member.member_unfreeze_date) }}</b>
    </ng-container>
  </p>
  <p *ngIf="!propExists(member.member_freeze_date)">
    Currently scheduled to be unfrozen on: <b>{{ dateStringFromISO8601(member.member_unfreeze_date) }}</b>
  </p>
</ng-container>

<div class="alert alert-danger" role="alert" *ngIf="errorMessage">
  {{ errorMessage }}
</div>
